module.exports = __webpack_public_path__ + "img/mobileGatheringInfo.3c507b26.svg";